import { useMemo } from 'react';

import { Deal } from '../gql/dealGql';
import { DealType, Maybe, useBanksQuery } from '../gql/generated/graphql';

import { isUneditable } from '../constants/dealStates';
import { isNullOrUndefined } from '../utils';
import { findBankName, getDefaultBankByDealType } from '../utils/financialInfos';

interface UseBanksProps {
  onlyActive?: boolean;
  deal?: Deal;
  isManuallySelectingBank?: boolean;
}

export const useBanks = (props: UseBanksProps = {}) => {
  const { onlyActive, deal, isManuallySelectingBank } = props;

  const dealIsUneditable = isUneditable(deal?.state);
  const dealHasSelectedCreditDecision = !!deal?.financial_info.selected_credit_decision;
  const keepSelectedBank =
    dealIsUneditable || (dealHasSelectedCreditDecision && !isManuallySelectingBank);

  const { data, loading, refetch } = useBanksQuery({
    variables: {
      state: deal?.customer?.address?.state,
      county: deal?.customer?.address?.county,
      active: onlyActive,
      selectedBank: keepSelectedBank ? deal?.financial_info?.bank : undefined,
      dealId: Number(deal?.id),
    },
  });

  const banks = useMemo(() => {
    if (!data?.banks?.length) {
      return [];
    }

    return data?.banks.filter((bank) => !isNullOrUndefined(bank));
  }, [data?.banks]);

  return { banks, loading, refetch };
};

export const useDefaultBankName = (dealType?: DealType): Maybe<string> | undefined => {
  const { banks } = useBanks();

  return findBankName({ banks, bankSlug: getDefaultBankByDealType(dealType) });
};
